import React, { useState } from "react";
import { sendPostRequest } from "../utils";
import Form from "../components/residents/Form";
import Success from "../components/residents/Success";

const ResidentSubscription = () => {
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    emailNotifications: false,
    smsNotifications: false,
  });

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setIsLoading(true);
    setError("");

    if (!form.emailNotifications) {
      setError(
        "Vous devez accepter de recevoir occasionnellement des mises à jour par courrier électronique."
      );
      setIsLoading(false);
      return;
    }

    try {
      const response = await sendPostRequest("residents", form);
      if (response.ok) {
        setSuccess(true);
      } else {
        const { message } = await response.json();
        setError(message || "Subscription failed. Please try again.");
      }
    } catch (error) {
      console.log(error);
      setError("Subscription failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center flex-1 bg-gradient-to-br from-blue-100 via-sky-100 to-indigo-100 p-4 md:p-6 rounded-2xl shadow-lg">
      <div className="mx-auto bg-white p-6 md:p-10 border rounded-lg shadow-md w-auto md:w-[500px]">
        {!success && (
          <>
            <h1 className="text-2xl font-bold mb-1 text-center text-[#ea4b36]">
              Activez votre carte de résident
            </h1>
            <p className="text-center  mb-6 text-slate-600">
              Obtenez 15% de rabais du lundi 8h30 au vendredi, 15h00
            </p>
          </>
        )}
        {error && (
          <p className="text-red-500 bg-red-50 border-red-200 border text-base px-2 py-1 mb-4">
            {error}
          </p>
        )}
        {!success ? (
          <Form
            handleSubmit={handleSubmit}
            onInputChange={onInputChange}
            isLoading={isLoading}
            form={form}
          />
        ) : (
          <Success />
        )}
      </div>
    </div>
  );
};

export default ResidentSubscription;
